/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoEodModelsMachineProdRequest
 */
export interface EodMelcoEodModelsMachineProdRequest {
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsMachineProdRequest
     */
    device_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsMachineProdRequest
     */
    bar_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsMachineProdRequest
     */
    language?: string | null;
}

export function EodMelcoEodModelsMachineProdRequestFromJSON(json: any): EodMelcoEodModelsMachineProdRequest {
    return EodMelcoEodModelsMachineProdRequestFromJSONTyped(json, false);
}

export function EodMelcoEodModelsMachineProdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoEodModelsMachineProdRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'device_id': !exists(json, 'device_id') ? undefined : json['device_id'],
        'bar_code': !exists(json, 'bar_code') ? undefined : json['bar_code'],
        'language': !exists(json, 'language') ? undefined : json['language'],
    };
}

export function EodMelcoEodModelsMachineProdRequestToJSON(value?: EodMelcoEodModelsMachineProdRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'device_id': value.device_id,
        'bar_code': value.bar_code,
        'language': value.language,
    };
}


